/* dev-kit.js */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-slide]'));
    if (slides.length <= 1) return;

    let current = 0;
    let timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAuto() {
      timer = setInterval(next, 5000);
    }

    function resetAuto() {
      clearInterval(timer);
      startAuto();
    }

    carousel.querySelector('[data-next]')?.addEventListener('click', () => { next(); resetAuto(); });
    carousel.querySelector('[data-prev]')?.addEventListener('click', () => { prev(); resetAuto(); });

    // ── Swipe / drag support ──
    const THRESHOLD = 50;
    let startX = null;
    let isDragging = false;

    function onDragStart(x) {
      startX = x;
      isDragging = true;
      clearInterval(timer);
    }

    function onDragEnd(x) {
      if (!isDragging || startX === null) return;
      const delta = startX - x;
      if (Math.abs(delta) >= THRESHOLD) {
        delta > 0 ? next() : prev();
      }
      startX = null;
      isDragging = false;
      startAuto();
    }

    // Touch
    carousel.addEventListener('touchstart', (e) => onDragStart(e.touches[0].clientX), { passive: true });
    carousel.addEventListener('touchend',   (e) => onDragEnd(e.changedTouches[0].clientX), { passive: true });

    // Mouse
    carousel.addEventListener('mousedown',  (e) => { e.preventDefault(); onDragStart(e.clientX); });
    carousel.addEventListener('mouseup',    (e) => onDragEnd(e.clientX));
    carousel.addEventListener('mouseleave', (e) => { if (isDragging) onDragEnd(e.clientX); });

    startAuto();
  });
});
